const IntegrationNames = {
  HUBSPOT: "hubspot",
  SALESFORCE: "salesforce"
};

export default IntegrationNames;
